module.exports = __webpack_public_path__ + "static/media/dead-delete.9f331d39.svg";